import apiSlice from "./apiSlice";
const riskPackagesSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllRisk: builder.query({
            query: (req) => ({
                url: `Risk`,
                params: req
            }),
            keepUnusedDataFor: 1,
        }),
        getRiskPackages: builder.query({
            query: ({ projectId, type }) => {
                const params = new URLSearchParams();
                if (projectId) params.append("projectId", projectId);
                if (type) params.append("type", type);
                return `WBS?${params.toString()}`;
            },
        }),
    }),
})

export const { useGetRiskPackagesQuery, useLazyGetRiskPackagesQuery, useGetAllRiskQuery } = riskPackagesSlice
